import React from 'react';
import { Form } from 'react-final-form';
import useOSEmployee from '@ubeya/shared/hooks/employees/useOSEmployee';
import { OSProfileSidebar } from './ProfileSidebar';

export const OSEmployeeCard = ({ defaultData, clientProjectId, onClose }) => {
  const employeeId = defaultData?.id;

  const { isLoading, data, updateEmployee } = useOSEmployee({
    employeeId,
    contextProjectId: clientProjectId,
    contextShiftId: defaultData?.supplierShiftId
  });

  return (
    <Form
      initialValues={data}
      onSubmit={() => {}}
      render={(props) => (
        <OSProfileSidebar
          {...props.initialValues}
          updateEmployee={updateEmployee}
          isLoading={isLoading}
          onClose={onClose}
          onEdit={() => {}}
        />
      )}
    />
  );
};
